import VueRouter from 'vue-router';
import Intro from '@/components/page/Intro';
import MyPosition from '@/components/page/MyPosition';
import ProfileMain from '@/components/page/ProfileMain'
import login from '@/components/page/login';
import pagenotfound from '@/components/common/pagenotfound';
import PageFrame from '@/components/PageFrame';
import SharePosition from '@/components/page/SharePosition';
import SharePositionLanding from '@/components/page/SharePositionLanding';
import StatisMapAdmin from '@/components/page/admin/StatisMapAdmin';
import PositionSurvey from '@/components/page/SharePositionSurvey';
import SharePositionPro from '@/components/page/SharePositionPro';
import MyChattings from '@/components/page/MyChattings'
import Empty from '@/components/page/Empty'
import Home from '@/components/page/Home';
import SoccerJoinMain from '@/components/page/SoccerJoinMain'
import Ground from '@/components/page/Ground'
import AiHome from '@/components/page/AiHome'

// import GlobalStore from './GlobalStore';
// let store = null;

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path : '/',
            component : PageFrame,
            children : [
                {path : '/', component : Intro},
                {path : '/now', component : Home},
                {path : '/team', component : Empty},
                {path : '/help', component : Empty},
                {path : '/training', component : Empty},
                {path : '/position_pro', component : Home},
                {path : '/team_detail', component : Empty},
                {path : '/position', component : Home},
                {path : '/share/position/landing', component : SharePositionLanding},
                {path : '/parent_pay', component : Home},
                {path : '/training_main', component : Ground},
                {path : '/sportlight', component : Home},
                {path : '/soccer_join', component : SoccerJoinMain},
            ]
        },
        // {
        //     path : '/share/position/landing', component : SharePositionLanding
        // },
        {
            path : '/share',
            component : PageFrame,
            children : [
                {path : 'position', component : SharePosition},
                // {path : 'position/landing', component : SharePositionLanding},
                {path : 'position/survey', component : PositionSurvey},
                {path : 'position/pro', component : SharePositionPro},
            ]
        },
        {
            path : '/view',
            component : PageFrame,
            children : [
                {path : 'login', component : login},
                {path : 'home', component : AiHome},
                {path : 'member_talk', component : MyChattings},
                {path : 'myposition', component : MyPosition},
                {path : 'soccer_join', component : SoccerJoinMain},
                {path : 'soccer_learn', component : Ground},
                // {path : 'soccerjoin', component : MemberMain, props: route => ({data: {mode: route.query.data}})},
                {path : 'my', component : ProfileMain, meta : {requiresAuth : true}},
                {path : 'mercenary', component : SoccerJoinMain},
                {path : 'admin/statis/map', component : StatisMapAdmin},
                {path: 'mychat', component: MyChattings}
            ]
        },
        {path: "*", component: pagenotfound }

    ]
});

//페이지화면에서 로그인, 혹은 권한 체크시
router.beforeEach((to, from,next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
        // if(!GlobalStore.isLogin()){
        //     GlobalStore.checkLoginAndConfirm(() => {
        //         next()
        //     });
        //     return;
        // }
        // if(localStorage['loginInfo'] != null){

            // if(to.matched.some(route => route.meta.requiresCenter)) {
            //     if (!window.Vue.$cookies.get('center_token')) {
            //         store.commit('showAlert', '센터 지정 후 사용가능합니다.');
            //         if(from.path != '/emptycenter') router.push({ path: '/emptycenter' });
            //         return;
            //     }
            // }
            //
            // next();
        // } else {
        //     next('/login');
        // }
    }
    next();
});

// router.afterEach((to, from) => {
//
// });
//
// router.setStore = function(storeObj){
//     store = storeObj;
// }

export default router;
